'use strict';

export default function getUrlParameter (name, url='')
{
	let string = url.slice(url.indexOf('?'));

	let search = string.split('&');

	if (search[0])
	{
		search[0] = search[0].replace('?', '');
	}

	const slug = search.find(slug => slug.startsWith(name + '='));

	if (typeof slug === 'undefined') return undefined;

	return slug.slice((name + '=').length);
}